export const EXISTING_FIAT_CURRENCIES = {
  MXN: true,
  UGX: true,
  SDG: true,
  XOF: true,
  SEK: true,
  GNF: true,
  QAR: true,
  LYD: true,
  KWD: true,
  ISK: true,
  PAB: true,
  CHF: true,
  HRK: true,
  VND: true,
  TJS: true,
  AED: true,
  DKK: true,
  BGN: true,
  BHD: true,
  KZT: true,
  AFN: true,
  EURPS: true,
  HUF: true,
  PEN: true,
  TMT: true,
  CLP: true,
  TND: true,
  DOP: true,
  MAD: true,
  PHP: true,
  COP: true,
  ETB: true,
  LAK: true,
  BND: true,
  MDL: true,
  AMD: true,
  TRY: true,
  EUR: true,
  RON: true,
  NGN: true,
  CRC: true,
  PKR: true,
  PLN: true,
  BRL: true,
  ZAR: true,
  TWD: true,
  UYU: true,
  OMR: true,
  KES: true,
  ARS: true,
  UZS: true,
  RUB: true,
  DZD: true,
  KGS: true,
  XAF: true,
  TZS: true,
  AUD: true,
  KHR: true,
  IDR: true,
  BWP: true,
  MMK: true,
  NOK: true,
  CZK: true,
  GBP: true,
  BYN: true,
  GEL: true,
  AZN: true,
  UAH: true,
  ILS: true,
  GHS: true,
  JOD: true,
  HKD: true,
  CAD: true,
  SAR: true,
  JPY: true,
  EGP: true,
  NZD: true,
};
